const inlineStyles = {
    border: {
        stroke: '#ccd7e0',
        strokeWidth: '4px',
    },
};
export default inlineStyles;
